/**
 * handleLabel - Generates a snake_case label from an ID and translated label
 *
 * Extracted from client ProductForm.tsx (lines 153-158)
 * Combines an ID and a translation label into a snake_case string.
 * Used for generating consistent form field identifiers.
 *
 * @param id - The field identifier
 * @param label - The translated label text
 * @returns Snake-cased combination of id and label
 */

import { snakeCase } from "lodash";

export function handleLabel(id: string, label: string): string {
  return snakeCase(id + "+" + label);
}
